import React from "react"
import maplibregl from "maplibre-gl"
import styled from "styled-components"
import { breakpoints } from "../../../theme"

const MapWrapper = styled.div`
  height: 202px;
  width: 100%;
  position: relative;
  background-color: var(--page-color);

  @media (min-width: ${breakpoints.medium}px) {
    height: 334px;
  }

  .map {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .maplibregl-marker {
    cursor: pointer;

    &:hover {
      filter: saturate(1.2);
    }
  }
`

const Map = ({ pois, filteredPois }) => {
  const mapContainer = React.useRef(null)
  const map = React.useRef(null)
  const [lat] = React.useState(46.769968)
  const [lng] = React.useState(7.991249)
  const [zoom] = React.useState(6)
  const [markers, setMarkers] = React.useState([])

  React.useEffect(() => {
    setMarkers(
      pois.map(poi => {
        const popup = new maplibregl.Popup()
          .setHTML("<h2>" + poi.title + "</h2>")
          .setMaxWidth("300px")

        return {
          id: poi.id,
          marker: new maplibregl.Marker({ color: "var(--primary)" })
            .setPopup(popup)
            .setLngLat([poi.longitude, poi.latitude]),
        }
      })
    )
  }, [pois])

  /**
   * Initialize the map
   */
  React.useEffect(() => {
    if (map.current) return //stops map from intializing more than once

    map.current = new maplibregl.Map({
      container: mapContainer.current,
      style: `https://api.maptiler.com/maps/streets/style.json?key=${process.env.GATSBY_API_KEY_MAPTILER}`,
      center: [lng, lat],
      zoom: zoom,
      maxZoom: 18,
    }).addControl(new maplibregl.NavigationControl(), "top-right")
  }, [lat, lng, zoom])

  /**
   * Add markers
   */
  React.useEffect(() => {
    if (map.current) {
      return
    }

    if (filteredPois.length === 0) {
      return
    }

    const activePois = filteredPois.map(p => p.id)
    const bounds = new maplibregl.LngLatBounds()

    filteredPois.forEach(function (p) {
      bounds.extend(new maplibregl.LngLat(p.longitude, p.latitude))
    })

    for (let i = 0; i < markers.length; i++) {
      if (activePois.includes(markers[i].id)) {
        markers[i].marker.addTo(map.current)
      } else {
        markers[i].marker.remove()
      }
    }
    map.current.fitBounds(bounds, { padding: 50 })
  }, [markers, filteredPois, map])

  return (
    <MapWrapper>
      <div ref={mapContainer} className="map" />
    </MapWrapper>
  )
}

export default Map
